import styled from 'styled-components';
import ModifySvg from '../../assets/mytrips/ic_modify.svg';

const ModifyHeaderSvg = styled(ModifySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '5.7rem'};
  height: ${props => props.height || '5.1rem'};
  margin: ${props => props.margin};
`;

export default ModifyHeaderSvg;
